import React from 'react';
import { Link } from 'react-router-dom';
import personImg from './assets/images/personImg3.png';

const MainPage = () => {

  const mainPageData = [
    {
      title: "IAM",
      text: <h5 style={{ color: "#515152" }} className="lh-base">Identity & Access <br/>Management</h5>,
      color: "#eb5424",
      to:'/demo/iam'
    },
    {
      title: "PAM",
      text: <h5 style={{ color: "#515152" }} className="lh-base">Privileged Access <br/>Management</h5>,
      color: "#5177FF",
      to:'/demo/pam'
    },
    {
      title: "CASB",
      text: <h5 style={{ color: "#515152" }} className="lh-base">Cloud Access <br/>Security Broker</h5>,
      color: "#B153FA",
      to:'/demo/casb'
    },
    {
      title: "DLP",
      text: <h5 style={{ color: "#515152" }} className="lh-base"> Data Loss Prevention<br/> </h5>,
      color: "#00A5AB",
      to:'/demo/dlp'
    },
    {
      title: "MDM",
      text: <h5 style={{ color: "#515152" }} className="lh-base">Mobile Device <br/>Management</h5>,
      color: "#FEC400",
      to:'/demo/mdm'
    },
    {
      title: "WordPress",
      text: <h5 style={{ color: "#515152" }} className="lh-base">WordPress Integration</h5>,
      color: "#5177FF",
      to:'/demo/wp'
    },
    {
      title: "Drupal",
      text: <h5 style={{ color: "#515152" }} className="lh-base">Drupal Integration</h5>,
      color: "#FEC400",
      to:'/demo/drupal'
    },
    {
      title: "Atlassian",
      text: <h5 style={{ color: "#515152" }} className="lh-base">Atlassian</h5>,
      color: "#00A5AB",
      to:'/demo/atlassian'
    }
  ]

  return (
    <div className='w-100 d-flex align-items-center justify-content-center row py-3 px-5' style={{ height: '91vh' }}>

      <div className='col-11'>
        <div className='row'>
          <div className='col-12 d-flex mb-4 justify-content-center align-items-center'>

            <h3 className='lh-base' style={{color:"#555555"}}>Take a look at the demonstration of our products and integrations</h3>

          </div>
          {mainPageData?.map((item) => (
            <div className='col-lg-3 col-12 col-md-6 p-2 '>
              <Link className='text-decoration-none'  to={item.to}>
              <div className='border rounded px-5 py-4 mainPageItems h-100'>
                <div className='d-flex w-100 justify-content-between align-items-center'>
                  <div style={{ width: "40px", height: "5px", background: `${item.color}`}} className="rounded"></div>
                  <span class="material-symbols-rounded text-dark">
                    east
                  </span>
                </div>
                <h4 className='fw-bold mt-4 my-3 text-black'>{item.title}</h4>
                {item.text}
              </div>
              </Link>
            </div>
          ))}
        </div>

      </div>

    </div>
  )
}

export default MainPage